import Loading from '../../../../Dashboards/Common/Loading';
import {
    ServicesPerMonthPerYearTotal,
    ServicesPerYearTotal
} from '../../../Common/Services/charts/apex-charts';
import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';

const Discharge = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div className="charts-side-by-side-dashboards">
            <ServicesPerYearTotal />
            <ServicesPerMonthPerYearTotal />
        </div>
    );
};

export default Discharge;
